module.exports = __webpack_public_path__ + "a95b7a79c6e34ad8b15af9e0fef1ba9f.png";